module.exports = __webpack_public_path__ + "media/theme/wall__sidebar--mobage-06c0255d.svg";